/**
 * `loadPageData`: the server function every content route's loader calls.
 *
 * During SSR TanStack Start invokes the handler in-process; the result is
 * dehydrated into the HTML, so hydration needs no request. A (rare) client-side
 * navigation turns it into a GET to the server. Either way the content catalog
 * itself (`./page-data.ts` -> `./localized.ts`) stays on the server: the
 * TanStack Start compiler strips the handler and its imports from the browser
 * bundle.
 */
import { createServerFn } from '@tanstack/react-start'
import { buildPageData, parsePageDataRequest } from './page-data'
import type { PageData, PageDataRequest } from './page-data'

export const loadPageData = createServerFn({ method: 'GET' })
  .validator((input: PageDataRequest) => parsePageDataRequest(input))
  .handler(({ data }): PageData => buildPageData(data))
